import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class ImportShopSearchParams extends SearchParamsBase {
  initialize() {
    this.ImportShopId = '';
    this.SurveyId = '';
    this.FormId = '';
    this.FormName = '';
    this.FormVersion = '';
    this.SubmissionId = '';
    this.UserLocId = '';
    this.FileName = '';
    this.Status = '';
    this.ApolloJobId = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.addDaysToDate(new Date(), -7);
    this.EndDate = dateTimeHelper.indefiniteDateValue();
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'FormId', label: 'FormId (Apollo Survey Id)', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'SubmissionId', label: 'SubmissionId', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ApolloJobId', label: 'Apollo Or Caspian JobId', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'UseDateRange', label: 'Use Date Range', className: 'col-4', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date (Created On)',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date (Created On)',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: ImportShopSearchParams.getStatusSelectOptions(),
    },
    { fieldName: 'UserLocId', label: 'UserLocId', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ImportShopId', label: 'ImportShop Id', className: 'col-4', type: InputTypesEnum.Number },
    // {fieldName:"FormVersion",label:"FormVersion", className:"col-3", type: InputTypesEnum.Text},
    // {fieldName:"FileName",label:"FileName", className:"col-3", type: InputTypesEnum.Text},
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ImportShopSearchParams';
  static maxWidth = 1000;
  static iconName = 'fa-solid fa-search';

  //---------------------------

  static getStatusSelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      'Received in BARE DB',
      'Successfully Imported',
      'Successfully Saved To Caspian',
      'Import Failed',
    ]);
  }
}
